module.exports = __webpack_public_path__ + "img/jhakaasbg.0b872e75.svg";